<sym-content-card>
    <div class="grid-container">
        <div *ngFor="let constraint of constraints;let i = index">
            <div class="input-container" [class.remove-bottom]="i === constraints.length - 1 || i === constraints.length - 2">
                <span class="line-header">{{constraint.name}}</span>
                <span class="line-content">{{constraint.value}}{{constraint.name.includes('Pipe') ? ' mm' : ''}}</span>
            </div>
        </div>
    </div>
</sym-content-card>